export function formatDate(dateString: string) {
  const date = new Date(dateString);

  // Get month, day, and year
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
}

export function formatDateMMddyyyy(dateString: string) {
  const date = new Date(dateString);

  const monthName = date.toLocaleString("default", { month: "short" });
  const dateDay = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${monthName} ${dateDay}, ${year}`;
}

export function sortDatesInAscendingOrder(array: any, dateKey: string) {
  return array.sort((a: any, b: any) => new Date(b[dateKey]).valueOf() - new Date(a[dateKey]).valueOf());
}

export function sortDatesOldtoNew(array: any[], dateKey: string) {
  return array.sort((a, b) => new Date(a[dateKey]).valueOf() - new Date(b[dateKey]).valueOf());
}

// retrun YYYY
export function getYear(dateStr: string) {
  const date = new Date(dateStr);
  // const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  return `${year}`;
}

// return DD YYYY
export function getDDYYYY(dateStr: string) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  return `${day}, ${year}`;
}

// Return Aug 19 UTC
// 2025-07-22
export function getMonthDateUTC(timestamp: string, capitalize?: boolean): string {
  const date = new Date(timestamp);
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return capitalize ? formattedDate : formattedDate;
}

export function getMonthNewDateUTC(timestamp: string): string {
  if (!timestamp) return "";
  const dateParts = timestamp.split(/[-T:]/).map(Number);
  const date = new Date(
    Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5])
  );
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate;
}

// Return Aug 19
export function getMonthDate(dateStr: string, capitalize?: boolean) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
  };
  if (capitalize) return date.toLocaleDateString("en-US", options);
  else return date.toLocaleDateString("en-US", options);
}

// return YYYY
export function getYearYYYY(dateStr: string) {
  if (!dateStr) return "";
  return new Date(dateStr).getUTCFullYear();
}

// Return Fri
export function getDayOfWeek(dateStr: string, type?: "long" | "short") {
  if (!type) type = "short";
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    weekday: type === "long" ? "long" : "short",
  };
  return type === "long" ? date.toLocaleDateString("en-US", options) : date.toLocaleDateString("en-US", options);
}

export function getDayOfWeekUTC(dateStr: string, type?: "long" | "short") {
  if (!type) type = "short";
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    weekday: type === "long" ? "long" : "short",
    timeZone: "UTC",
  };
  return type === "long" ? date.toLocaleDateString("en-US", options) : date.toLocaleDateString("en-US", options);
}

// Return true if two dates are same
export function isSameDate(timestamp1: string, timestamp2: string): boolean {
  if (!timestamp1 || !timestamp2) return false;
  const date1 = timestamp1.split("-");
  const date2 = timestamp2.split("-");
  return date1[0] === date2[0] && date1[1] === date2[1] && date1[2] === date2[2].substring(0, 2);
}

// return time in 12 hours EG: 4:32pm
export function getTwelveHourTimeFormat(dateStr: string) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleTimeString("en-US", options);
}

// get the time difference
export function getTimeDifference(startDateStr: string, endDateStr: string) {
  if (!startDateStr || !endDateStr) return "";
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Calculate the difference in milliseconds
  const diffInMs = Math.abs(endDate.getTime() - startDate.getTime());

  // Convert milliseconds to hours and minutes
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  return `${hours}h ${minutes}m`;
}

export function formatToYYYYMMDD(dateStr: string): string {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}

//FRI, AUG 15, 2025
export const formatNewDepartureDate = (dateString: string): string => {
  if (!dateString) {
    return "Date not available";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const day = days[date.getDay()];
  const month = months[date.getMonth()];
  const dayOfMonth = date.getDate();
  const year = date.getFullYear();

  return `${day}, ${month} ${dayOfMonth}, ${year}`;
};

//FRI, AUG 15, 2025 — timezone-safe variant for DATE-ONLY strings ("YYYY-MM-DD").
// `new Date("2026-08-30")` is parsed as UTC midnight, so the local-time getters used by
// formatNewDepartureDate render the PREVIOUS day for any user behind UTC (e.g. "Sat, Aug 29, 2026").
// Hotel check-in/check-out are date-only, and the rest of the app already reads them in UTC
// (getMonthDateUTC / getDayOfWeekUTC), so use the UTC getters here to match.
export const formatNewDepartureDateUTC = (dateString: string): string => {
  if (!dateString) {
    return "Date not available";
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const day = days[date.getUTCDay()];
  const month = months[date.getUTCMonth()];
  const dayOfMonth = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${day}, ${month} ${dayOfMonth}, ${year}`;
};

// return time in 12 hours EG: 4:32pm without space
export function getTwelveHourTimeFormate(dateStr: string) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleTimeString("en-US", options).replace(" ", "");
}

export const formatDateToYYYYMMDD = (dateInput: Date | string): string => {
  try {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
};

// return date as YYYY-MM-DD
export function getStartDateForItinerary(startDate: any): string {
  // Get today's date without time (to compare properly)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Check if startDate is a valid date in YYYY-MM-DD format
  const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(startDate) && !isNaN(new Date(startDate).getTime());

  if (isValidDate) {
    const providedDate = new Date(startDate);
    providedDate.setHours(0, 0, 0, 0); // Remove time for accurate comparison

    // If the provided date is today or in the future, return it
    if (providedDate >= today) {
      return startDate;
    }
  }

  // If invalid or past date, return next month’s date
  const nextMonthDate = new Date();
  nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  const year = nextMonthDate.getFullYear();
  const month = String(nextMonthDate.getMonth() + 1).padStart(2, "0");
  const day = String(nextMonthDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const calcNoOfDaysSelected = (startDate: string, endDate: string): number => {
  // Handle empty or invalid dates
  if (!startDate || !endDate) return 0;

  // Convert string dates to Date objects
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate difference in milliseconds
  const diffTime = Math.abs(end.getTime() - start.getTime());

  // Convert to days and add 1 to include both start and end dates
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

  return diffDays;
};

export function addDaysToDate(dateString: string, number_of_days: any): string {
  const date = new Date(dateString);
  date.setDate(date.getDate() + Number(number_of_days));
  return date.toISOString(); // or return date.toDateString(), etc.
}

export function travelerFormIsValidDate(monthName: string, day: number, year?: number): boolean {
  const useYear = year ?? new Date().getFullYear();

  // Normalize month input (case-insensitive)
  const normalizedMonth = monthName.charAt(0) + monthName.slice(1).toLowerCase();

  // Convert month string to index
  const monthIndex = new Date(`${normalizedMonth} 1, ${useYear}`).getMonth();

  if (isNaN(monthIndex)) return false; // Invalid month

  const testDate = new Date(useYear, monthIndex, day);

  return testDate.getFullYear() === useYear && testDate.getMonth() === monthIndex && testDate.getDate() === day;
}

export function getHistoryCreatedDaysAgo(createdAt: string): string {
  // Extract ISO part if your input has junk like "25-62025-07-25T09:09:06.101Z"
  const match = createdAt.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z/);
  if (!match) return "Invalid date";

  const date: any = new Date(match[0]);
  const now: any = new Date();
  const diff = now - date; // in ms

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return `${seconds}s ago`;
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;
  if (weeks < 5) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
  return `${years} year${years > 1 ? "s" : ""} ago`;
}

export function formatDateWithSuffix(input: string) {
  try {
    // Split month & day
    const parts = input.trim().split(" ");
    const month = parts[0];
    const day = parseInt(parts[1], 10);

    if (isNaN(day)) return input;

    const suffix = getDaySuffix(day);

    return `${month} ${day}${suffix}`;
  } catch {
    return input;
  }
}

// Helper function to add st / nd / rd / th
function getDaySuffix(day: number) {
  if (day >= 11 && day <= 13) return "th"; // special cases

  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
